module.exports = __webpack_public_path__ + "static/media/heathrow-logo-charcoal.ffb02e81.svg";